import { ServiceId } from "@mirage/discovery/id";
import * as services from "@mirage/discovery/services";
import type {
  ConversationEventWithUuid,
  FSSActionEvent,
  FSSFile,
  UnavailableSource,
} from "@mirage/service-fss-bridge/service/bridge_types";
import type { Observable } from "rxjs";

export type Service = {
  isSupportedEnv: () => boolean;
  readyPage: () => Promise<void>;
  openAddSourceModal: () => Promise<void>;
  updateConversation: (conversationID: string) => Promise<void>;
  closeSidebar: () => Promise<void>;
  notifyLogin: (uid: number) => Promise<void>;
  notifyLogout: () => Promise<void>;
  openSessionHistory: () => Promise<void>;
  openUnavailableSources: (
    unavailableSources: UnavailableSource[],
  ) => Promise<void>;
  updateCloseButton: (hide: boolean) => Promise<void>;
  transcribeFiles: (files: FSSFile[]) => Promise<void>;
  // STACKS FUNCTIONS START
  notifyInStackDetailPage: (
    stackId: string,
    stackName?: string,
    isChatEnabled?: boolean,
    files?: FSSFile[],
  ) => Promise<void>;
  notifyInStacksPage: () => Promise<void>;
  notifyInNewStackPage: () => Promise<void>;
  startStackChat: (files: FSSFile[]) => Promise<void>;
  // STACKS FUNCTIONS END

  // New event-based observables
  observeConversationEvents: () => Observable<
    ConversationEventWithUuid | undefined
  >;
  observeActionEvents: () => Observable<FSSActionEvent | undefined>;
};

export default function fssBridgeService(serviceImpl: Service) {
  return services.provide(ServiceId.FSS_BRIDGE, serviceImpl, []);
}
